import { render, staticRenderFns } from "./payment-info-documents.vue?vue&type=template&id=0787610a&scoped=true&"
import script from "./payment-info-documents.vue?vue&type=script&lang=js&"
export * from "./payment-info-documents.vue?vue&type=script&lang=js&"
import style0 from "./payment-info-documents.vue?vue&type=style&index=0&id=0787610a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787610a",
  null
  
)

export default component.exports